@if (isLoading) {
  <div class='sideBarContent content loading-spinner'></div>
}
@if (!isLoading) {
  <div class="sideBarContent content">
    <irb-editor-sidebar-banner
      [accordian]="accordion"
      [showUnsavedChangesWarning]="showUnsavedChangesWarning"
      [isModified]="isModified"
      [isValid]="isValid"
      [hasPendingFunction]="hasPendingFunction"
      [slot]="slot"
      (save)="save()"
      (cancel)="cancel()"><span header class="ms-header" tooltip [tooltipTitle]="'Edit Security'" [tooltipRequiresTruncation]="true">Edit Security</span></irb-editor-sidebar-banner>
      <div class="body" [style.height]="bodyHeight" #body class="edit-security-container-page body">
        <div class="block editorDisplayBanner">
          <div class="left" style="display: flex;">
            <div class="editorDispalybannerHeader edit-security-symbol-container" style="min-width:100px;">
              <div class="editorDispalybannerText">
                @if (isAllowedToEditHeader()) {
                  <p #securitySymbol>Symbol | <strong><a id="editLink"
                  (click)="showInlineEditSymbol()">edit</a></strong>
                </p>
              }
              @if (!isAllowedToEditHeader()) {
                <p #securitySymbol>Symbol</p>
              }
            </div>
            @if (!showInLineeditFlagSymbol) {
              <span class="editorDispalyValueText security-symbol-truncate"
                tooltip
                [tooltipTitle]="data?.securitySymbol"
                [tooltipRequiresTruncation]="true"
                tooltipPosition="bottom">
                {{data?.securitySymbol}}
              </span>
            }
            @if (showInLineeditFlagSymbol) {
              <irb-com-inlineedit [(tooltipMessage)]="tooltipMessageSymbol"
                defaultTooltip="Invalid Security Symbol"
                [regExp]="regExp"
                [customValidationFunction]="checkIfValidCustomSymbol"
                [(data)]="data.securitySymbol"
                [maxlength]="25"
                (save)="saveInlineEditSymbol($event)"
                (close)="closeInlineEditSymbol()"
                [allowSpecialCharacters]="false"
              (change)="onSymbolTextChange()"></irb-com-inlineedit>
            }
          </div>
          @if (editModel) {
            <div class="editorDispalybannerHeader">
              <div class="editorDispalybannerText"><p>Target %</p></div>
              <div class="editorDispalyValueText edit-security-header-model-name">{{targetPercentage}}</div>
            </div>
          }
          <div class="editorDispalybannerHeader"
            style="min-width: 200px;word-break: break-word;white-space: normal;"  [ngClass]="{'edit-security-model-description':editModel}">
            <div class="editorDispalybannerText">
              @if (isAllowedToEditHeader()) {
                <p #securityDescription>Description | <strong><a id="editLinkDesc"
                (click)="showInlineEditSymbolDesc()">edit</a></strong>
              </p>
            }
            @if (!isAllowedToEditHeader()) {
              <p #securityDescription>Description</p>
            }
          </div>
          @if (!showInLineeditFlagSymbolDesc) {
            <span class="editorDispalyValueText security-description-truncate"
              tooltip
              [tooltipTitle]="data?.securityDescription"
              [tooltipRequiresTruncation]="true"
              tooltipPosition="bottom">
              {{data?.securityDescription}}
            </span>
          }
          @if (showInLineeditFlagSymbolDesc) {
            <irb-com-inlineedit [(tooltipMessage)]="tooltipMessageSymbolDesc"
              defaultTooltip="Please provide valid Description name."
              [(data)]="data.securityDescription"
              [maxlength]="255"
              (save)="saveInlineEditSymbolDesc($event)"
              (close)="closeInlineEditSymbolDesc()"
            (change)="onSymbolDescTextChange()"></irb-com-inlineedit>
          }
        </div>
      </div>
      <div class="right"  style="display: flex;">
        @if (!editModel) {
          <div class="editorDispalybannerHeader" style="width: 150px;">
            <div class="editorDispalybannerText"><p #lastEdit>Date Last Edited / By</p></div>
            @if (data?.modifiedDate!=null) {
              <span
                class="editorDispalyValueText">{{data?.modifiedDate | easternTime | date:'MM/dd/yyyy h:mm a'}}
              ET</span>
            }
            <div>{{data?.modifiedBy}}</div>
          </div>
        }
        <div class="editorDispalybannerHeader" style="width: 75px;">
          <div class="editorDispalybannerText"><p #securityType>{{ENABLE_AS_SECTYPE ? 'Trade Type' : 'Type'}}</p></div>
          <span class="editorDispalyValueText">{{formatSecurityType(data?.securityType)}}</span>
        </div>
        @if (editModel) {
          <div class="editorDispalybannerHeader">
            <div class="editorDispalybannerText"><p>Model Name</p></div>
            <div class="editorDispalyValueText edit-security-header-model-name">{{modelName}}</div>
          </div>
        }
      </div>
      <br class="clear"/>
    </div>
    <mat-accordion #accordion="matAccordion" [multi]="true">
        @if (ENABLE_SECURITY_HISTORY) {
            <mat-expansion-panel id="SECURITY_HISTORY" [expanded]="ies.getDefaultExpansionState('SECURITY_HISTORY')"
                                 (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('SECURITY_HISTORY','opened') : ies.updateExpansionState('SECURITY_HISTORY','opened')"
                                 (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('SECURITY_HISTORY','closed') : ies.updateExpansionState('SECURITY_HISTORY','closed')">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Security History
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <irb-security-history [securityId]="securityEventData.securityId"></irb-security-history>
                </ng-template>
            </mat-expansion-panel>
        }
      @if (data) {
        <mat-expansion-panel id="ASSET_CLASSES"
          [expanded]="ies.getDefaultExpansionState('ASSET_CLASSES')"
          (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('ASSET_CLASSES','opened') : ies.updateExpansionState('ASSET_CLASSES','opened')"
          (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('ASSET_CLASSES','closed') : ies.updateExpansionState('ASSET_CLASSES','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Schwab&reg; Asset Classes
            </mat-panel-title>
          </mat-expansion-panel-header>
          <irb-com-ac-levels [id]="data.securityId"></irb-com-ac-levels>
        </mat-expansion-panel>
      }
      @if (isVisible('ASSET_CATEGORY')) {
        <mat-expansion-panel id="ASSET_CATEGORY"
          [expanded]="ies.getDefaultExpansionState('ASSET_CATEGORY')"
          (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('ASSET_CATEGORY','opened') : ies.updateExpansionState('ASSET_CATEGORY','opened')"
          (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('ASSET_CATEGORY','closed') : ies.updateExpansionState('ASSET_CATEGORY','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Asset Category
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (!isUiTest) {
            <irb-security-asset-category [securityAssetCategoryData]="_tradingMinimumData"
              (categoryChanged)="onCustomAssetCategoryChanged($event)"
              #assetCategoryComponent>
            </irb-security-asset-category>
          }
        </mat-expansion-panel>
      }
      @if (isVisible('COMPONENT_SECURITIES')) {
        <mat-expansion-panel id="COMPONENT_SECURITIES"
          [expanded]="ies.getDefaultExpansionState('COMPONENT_SECURITIES')"
          (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('COMPONENT_SECURITIES','opened') : ies.updateExpansionState('COMPONENT_SECURITIES','opened')"
          (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('COMPONENT_SECURITIES','closed') : ies.updateExpansionState('COMPONENT_SECURITIES','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Component Securities
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (!isUiTest) {
            <irb-component-securities [componentSecuritiesData]="_tradingMinimumData"
              (groupSecurityChanged)="onGroupSecurityChanged($event)"
              (deletedSecIdListChanged)="onDeletedSecIdListChanged($event)"
            #componentSecuritiesComponent></irb-component-securities>
          }
        </mat-expansion-panel>
      }
      @if (isVisible('TRADING_MINIMUMS')) {
        <mat-expansion-panel id="TRADING_MINIMUMS"
          [expanded]="ies.getDefaultExpansionState('TRADING_MINIMUMS')"
          (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('TRADING_MINIMUMS','opened') : ies.updateExpansionState('TRADING_MINIMUMS','opened')"
          (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('TRADING_MINIMUMS','closed') : ies.updateExpansionState('TRADING_MINIMUMS','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Trading Minimums
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (isCashSecurityProfile()) {
            <div>Not applicable for $CASH Security Profile</div>
          }
          @if (!isCashSecurityProfile() && !isUiTest) {
            <div>
              <irb-trading-minimums [tradingMinimumData]="_tradingMinimumData" [editModel]="editModel"
                (dollarPercentChanged)="onTradingMinimumsChanged($event)"
                (alternateSecurityChanged)="onTradingMinimumAlternateSecurityChanged($event)"
              #tradingMinimumsComponent></irb-trading-minimums>
            </div>
          }
        </mat-expansion-panel>
      }
      @if (isVisible('PENALTIES')) {
        <mat-expansion-panel id="PENALTIES"
          [expanded]="ies.getDefaultExpansionState('PENALTIES')"
          (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('PENALTIES','opened') : ies.updateExpansionState('PENALTIES','opened')"
          (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('PENALTIES','closed') : ies.updateExpansionState('PENALTIES','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Penalties
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (!isUiTest) {
            <irb-security-penaltybar [penaltyBarData]="_tradingMinimumData"
            #securityPenaltybarComponent></irb-security-penaltybar>
          }
        </mat-expansion-panel>
      }
      @if (isVisible('RESTRICTIONS')) {
        <mat-expansion-panel id="RESTRICTIONS"
          [expanded]="ies.getDefaultExpansionState('RESTRICTIONS')"
          (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('RESTRICTIONS','opened') : ies.updateExpansionState('RESTRICTIONS','opened')"
          (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('RESTRICTIONS','closed') : ies.updateExpansionState('RESTRICTIONS','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Restrictions
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (isCashSecurityProfile()) {
            <div>Not applicable for $CASH Security Profile</div>
          }
          @if (!isCashSecurityProfile() && !isUiTest) {
            <div>
              <irb-security-restrictions [securityRestrictionsData]="_tradingMinimumData"
                (restrictionChanged)="onSecurityRestrictionChanged($event)"
              #securityRestrictionsComponent></irb-security-restrictions>
            </div>
          }
        </mat-expansion-panel>
      }
      @if (isVisible('EQUIVALENTS_ALTERNATIVES')) {
        <mat-expansion-panel id="EQUIVALENTS_ALTERNATIVES"
          [expanded]="ies.getDefaultExpansionState('EQUIVALENTS_ALTERNATIVES')"
          (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('EQUIVALENTS_ALTERNATIVES','opened') : ies.updateExpansionState('EQUIVALENTS_ALTERNATIVES','opened')"
          (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('EQUIVALENTS_ALTERNATIVES','closed') : ies.updateExpansionState('EQUIVALENTS_ALTERNATIVES','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Equivalents & Alternatives
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (isCashSecurityProfile()) {
            <div>Not applicable for $CASH Security Profile</div>
          }
          @if (!isCashSecurityProfile() && !isUiTest) {
            <div>
              <irb-security-equivalents-alternatives [securityEquivalentsAlternativesData]="_tradingMinimumData"
                (securityEquivalentsChanged)="onSecurityEquivalentsChanged($event)"
                (securityEquivalentsAlternativeChanged)="onSecurityEquivalentsAlternativeChanged($event)"
              #securityEquivalentsAlternativesComponent></irb-security-equivalents-alternatives>
            </div>
          }
        </mat-expansion-panel>
      }
      @if (isVisible('TLH_WASH_SALE_ALTERNATIVES') && isTlhWsaEnabled) {
        <mat-expansion-panel id="TLH_WASH_SALE_ALTERNATIVES"
          [expanded]="ies.getDefaultExpansionState('TLH_WASH_SALE_ALTERNATIVES')"
          (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('TLH_WASH_SALE_ALTERNATIVES','opened') : ies.updateExpansionState('TLH_WASH_SALE_ALTERNATIVES','opened')"
          (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('TLH_WASH_SALE_ALTERNATIVES','closed') : ies.updateExpansionState('TLH_WASH_SALE_ALTERNATIVES','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Tax Loss Harvesting and Wash Sale Alternates
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (isCashSecurityProfile()) {
            <div>Not applicable for $CASH Security Profile</div>
          }
          @if (!isCashSecurityProfile() && !isUiTest) {
            <div>
              <irb-tlh-wash-sale-alternatives [securityTLHData]="_tradingMinimumData"
                (securityTLHWashSaleEquivalentsChanged)="onSecurityTLHWashSaleEquivalentsChanged($event)"
              #tLHWashSaleAlternativesComponent></irb-tlh-wash-sale-alternatives>
            </div>
          }
        </mat-expansion-panel>
      }
      @if (isVisible('HOUSEHOLD_LOCATION_PREFERENCES')) {
        <mat-expansion-panel id="HOUSEHOLD_LOCATION_PREFERENCES"
          [expanded]="ies.getDefaultExpansionState('HOUSEHOLD_LOCATION_PREFERENCES')"
          (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('HOUSEHOLD_LOCATION_PREFERENCES','opened') : ies.updateExpansionState('HOUSEHOLD_LOCATION_PREFERENCES','opened')"
          (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('HOUSEHOLD_LOCATION_PREFERENCES','closed') : ies.updateExpansionState('HOUSEHOLD_LOCATION_PREFERENCES','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Household Location Preferences
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (!isUiTest) {
            <irb-household-location-preferences
              [householdLocationPreferencesData]="_tradingMinimumData"
              (rothLevelChanged)="onRothLevelChanged($event)"
              (levelChanged)="onLevelChanged($event)"
              #householdLocationPreferencesComponent>
            </irb-household-location-preferences>
          }
        </mat-expansion-panel>
      }
      @if (isVisible('EXTERNAL_HOLDINGS')) {
        <mat-expansion-panel id="EXTERNAL_HOLDINGS"
          [expanded]="ies.getDefaultExpansionState('EXTERNAL_HOLDINGS')"
          (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('EXTERNAL_HOLDINGS','opened') : ies.updateExpansionState('EXTERNAL_HOLDINGS','opened')"
          (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('EXTERNAL_HOLDINGS','closed') : ies.updateExpansionState('EXTERNAL_HOLDINGS','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              External Holdings
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (!isUiTest) {
            <irb-external-share-holding
              [externalShareHoldingData]="_tradingMinimumData"
              (externalShareHoldingPriceChanged)="onExternalSharePriceChange($event)"
            #externalShareHoldingComponent></irb-external-share-holding>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
</div>
}
